import "./Especialidades.css";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Especialidades() {
    const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  const items = [
    { icon: "rebase_edit", title: "Urologia Reconstrutora", text: "Correção de estenose de uretra e malformações." },
    { icon: "settings_accessibility", title: "Cirurgia Funcional", text: "Restauração da fisiologia urológica." },
    { icon: "bolt", title: "Disfunção Erétil", text: "Tratamentos clínicos e cirúrgicos avançados." },
    { icon: "medical_services", title: "Prótese Peniana", text: "Soluções definitivas para saúde sexual." },
    { icon: "architecture", title: "Doença de Peyronie", text: "Tratamento de curvaturas e placas." },
    { icon: "monitoring", title: "Próstata", text: "Hiperplasia (HPB) e Câncer." },
    { icon: "water_drop", title: "Incontinência Urinária", text: "Recuperação do controle esfincteriano." },
    { icon: "grain", title: "Cálculos Renais", text: "Tecnologia minimamente invasiva." },
    { icon: "biotech", title: "Câncer de rim", text: "Diagnóstico precoce e nefrectomia parcial." },
    { icon: "science", title: "Câncer de bexiga", text: "Tratamento endoscópico e oncológico." }
  ];

  return (
    <section className="especialidades-section" id="especialidades">
      <div className="container">

        {/* HEADER */}
        <div className="especialidades-header scroll-reveal-opacity">
          <h2>Especialidades e Procedimentos</h2>
          <div className="linha"></div>
        </div>

        {/* GRID */}
<div className="row g-3 justify-content-center">

  {items.map((item, index) => (
    <div
      key={index}
      className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-custom scroll-reveal-opacity"
    >
              <div className="especialidade-card">

                <span className="material-symbols-outlined icon">
                  {item.icon}
                </span>

                <h3>{item.title}</h3>

                <p>{item.text}</p>

              </div>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default Especialidades;